import React, { createContext, useCallback, useContext, useMemo, useState } from "react"

const AppContext = createContext()

export function WebinarAppContext({
  children,
  initialRoomId,
  initialRole,
  promotions,
  setWebinarAnnouncement,
  startDate,
  title,
  trackingId,
  durationInMinutes,
  emailSource,
  emailList,
  email,
  signedUpForNativeWebinar,
}) {
  const [view, setView] = useState("preview")
  const [roomId, setRoomId] = useState(initialRoomId)
  const [role, setRole] = useState(initialRole)

  const goToRoot = useCallback(() => setView("/"), [])
  const goToMeeting = useCallback(() => setView("meeting"), [])
  const goToStreaming = useCallback(() => setView("streaming"), [])
  const goToPreview = useCallback(() => setView("preview"), [])
  const leaveMeeting = useCallback(() => setView("leave"), [])

  const setAppRoomId = useCallback((id) => setRoomId(id), [])
  const setAppRole = useCallback((userRole) => setRole(userRole), [])

  const value = useMemo(
    () => ({
      view,
      roomId,
      role,
      goToRoot,
      goToMeeting,
      goToStreaming,
      goToPreview,
      leaveMeeting,
      setAppRoomId,
      setAppRole,
      promotions,
      setWebinarAnnouncement,
      startDate,
      title,
      trackingId,
      durationInMinutes,
      emailSource,
      emailList,
      email,
      signedUpForNativeWebinar,
    }),
    [
      view,
      roomId,
      role,
      goToRoot,
      goToMeeting,
      goToStreaming,
      goToPreview,
      leaveMeeting,
      setAppRoomId,
      setAppRole,
      promotions,
      setWebinarAnnouncement,
      startDate,
      title,
      trackingId,
      durationInMinutes,
      emailSource,
      emailList,
      email,
      signedUpForNativeWebinar,
    ],
  )

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export function useWebinarAppContext() {
  const context = useContext(AppContext)
  if (context === undefined) {
    throw new Error("useWebinarAppContext must be used within an WebinarAppContext")
  }
  return context
}
